import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../lib/context'

// const variants = {
//     initial: {
//         opacity: 0 ,
//         // transform: "translateY(100%)"
//     },
//     enter: {
//         opacity: 1,
//         // transform: "translateY(0px)",
//         transition: {
//             duration: .3,
//             delay: .02
//         }
//     },
//     exit: {
//         opacity: 0,
//         transition: {
//             duration: .3,
//         }
//     }
// }

const TransitionEl = observer(() => {
    const {uiStore: {articleColors}, transitionStore: {isInitialLoad, routePath, routeTransitioning, transitionStartExit}} = useStore();
    const transitionColor = articleColors[routePath] ? articleColors[routePath] : "var(--color--offWhite)";

    return (
        <div style={{background: transitionColor}} className={`tr-el ${isInitialLoad ? "nt" : ""} ${routeTransitioning ? "tr-el--1" : ""} ${transitionStartExit ? "tr-el--2" : ""}`}>
            <style jsx>{`
                .tr-el {
                    position: fixed;
                    z-index: 1003;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    display: none;
                    transform: translate3d(0, 100%, 0);
                    transition: none;
                    background: var(--color--offWhite);
                 }

                 .tr-el--1 {
                    // transform: translate3d(0, 0, 0);
                    // transition: transform .6s cubic-bezier(0.33, 1, 0.68, 1);
                 }

                 .tr-el--2 {
                    // transform: translate3d(0, -100%, 0);
                    // transition: transform .6s cubic-bezier(0.33, 1, 0.68, 1);
                 }

                 .nt {
                    // transform: translate3d(0, 100%, 0) !important;
                    // transition: none; 
                 }
            `}</style>
        </div>
    )
    // return (
    //     <AnimatePresence exitBeforeEnter>
    //         {
    //             routeTransitioning ? 
    //             <motion.div 
    //                 variants={variants}
    //                 initial="initial"
    //                 animate="enter"
    //                 exit="exit"
    //                 className="tr-el"
    //             ></motion.div>
    //             :
    //             null
    //         }

    //         <style jsx global>{`
    //                 .tr-el {
    //                     position: fixed;
    //                     z-index: 1003;
    //                     top: 0;
    //                     left: 0;
    //                     width: 100%;
    //                     height: 100%;
    //                     background: red;
    //                 }


    //             `}</style>
    //     </AnimatePresence>

    // )
})

export default TransitionEl